import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-146" data-mp="x53amt4m5r7k">
      <div className="mx-auto max-w-2xl" data-id="element-147" data-mp="121trvjs5msuk">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-148" data-mp="122vbicn8knnw">
          Domande frequenti
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-149" data-mp="1urtxxlye6bz0">
          Tutto ciò che potresti voler sapere
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-150" data-mp="1g0jxxowyc2v2">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-151" data-mp="28q0nmet6t5nl" data-mpi={index}>
                <h3 data-id="element-152" data-mp="2dik1zdzp84tg">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left" data-id="element-153" data-mp="2dj387xfzl4rn">
                    <span className="text-[14.5px] font-bold leading-snug text-navy" data-id="element-154" data-mp="2yhlcaspv7z76">{faq.q}</span>
                    <ChevronDownIcon className={`mt-0.5 h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-155" data-mp="2tnqwi0dds4dd" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-navy/10 px-4 py-4 text-[14px] leading-relaxed text-navy/70" data-id="element-156" data-mp="3cfjnjp8w3fig">{faq.a}</p>}
              </div>;
        })}
        </div>

        <CtaBlock className="mt-9" label="Sono pronto — voglio il mio accesso" data-id="element-157" data-mp="1i2bn9i25abpf" />
      </div>
    </section>;
}